<script setup>
import usePublicStore from "@/store/public";
import { storeToRefs } from "pinia";
import { useDatosGenerales } from "@/composables/usePublic";
import CTAContactoAsesor from "@/modules/public/components/CTAContactoAsesor";

const { listEstados, listMunicipios, loadingMunicipios } = storeToRefs(
  usePublicStore()
);
const { fetchMunicipiosByEstado } = usePublicStore();

const { showMoral, togglePersonaMoral, submitGenerales } = useDatosGenerales();
</script>

<template>
  <section>
    <form @submit.prevent="submitGenerales" id="formGeneral">
      <div class="row me-0">
        <div class="col-md-6 bg-light pt-5 px-4 px-md-0 pb-5 pb-mb-0">
          <div class="d-flex col-md-8 mx-auto border-bottom h-100">
            <div class="col-md-1 d-flex justify-content-center">
              <span>1</span>
            </div>
            <div class="col-md-11">
              <p>
                <b class="text-dark">Nombre completo</b><br />
                <span class="text-dark">
                  Tu nombre completo nos permite dirigirnos a ti de manera
                  personalizada y asegurarnos de que todos tus datos estén
                  correctamente registrados.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 pt-5 pb-5 pb-md-0">
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-12 col-md-9 px-3 px-md-0">
              <div class="form-group mb-4">
                <label for="nombre" class="text-lg">Nombre:</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Ingresa tu nombre aquí"
                  required
                />
              </div>
              <div class="form-group mb-4">
                <label for="paterno" class="text-lg">Apellido paterno:</label>
                <input
                  type="text"
                  id="paterno"
                  placeholder="Ingresa tu apellido paterno aquí"
                  name="paterno"
                  class="form-control"
                  autocomplete="off"
                  required
                />
              </div>
              <div class="form-group mb-4">
                <label for="materno" class="text-lg">Apellido materno:</label>
                <input
                  type="text"
                  id="materno"
                  name="materno"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Opcional"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bg-light pt-5 px-4 px-md-0 pb-5 pb-mb-0">
          <div class="d-flex col-md-8 mx-auto border-bottom h-100">
            <div class="col-md-1 d-flex justify-content-center">
              <span>2</span>
            </div>
            <div class="col-md-11">
              <p>
                <b class="text-dark">Estado y municipio</b><br />
                <span class="text-dark">
                  Selecciona tu estado y municipio de residencia. Esto nos ayuda
                  a entender tu ubicación geográfica y, en algunos casos, puede
                  ser relevante para la cotización.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 py-5">
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-12 col-md-9 px-3 px-md-0">
              <div class="form-group mb-4 position-relative">
                <label for="estado" class="text-lg">Estado:</label>
                <select
                  name="estado"
                  id="estado"
                  class="form-control"
                  required
                  @change="fetchMunicipiosByEstado($event.target.value)"
                >
                  <option value="">Seleccione</option>
                  <option
                    :value="id"
                    v-for="{ id, nombre } in listEstados"
                    :key="id"
                  >
                    {{ nombre }}
                  </option>
                </select>
                <div
                  v-if="loadingMunicipios"
                  class="spinner-border spinner-border-sm position-absolute end-0 mt-n4 me-4 text-primary"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div class="form-group mb-4">
                <label for="municipio" class="text-lg">Municipio:</label>
                <select
                  name="municipio"
                  id="municipio"
                  class="form-control"
                  required
                >
                  <option value="">Seleccione</option>
                  <option
                    :value="id"
                    v-for="{ id, nombre } in listMunicipios"
                    :key="id"
                  >
                    {{ nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bg-light pt-5 px-4 px-md-0 pb-5 pb-mb-0">
          <div class="d-flex col-md-8 mx-auto border-bottom h-100">
            <div class="col-md-1 d-flex justify-content-center">
              <span>3</span>
            </div>
            <div class="col-md-11">
              <p class="pb-3">
                <b class="text-dark">Tipo de registro ante hacienda</b><br />
                <span class="text-dark">
                  Tu tipo de registro ante hacienda indica si estás registrado
                  ante Hacienda como Persona Física o Moral. Esto es fundamental
                  para asegurarnos que las opciones de arrendamiento que te
                  ofrecemos se ajusten a tu situación legal.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 py-5">
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-12 col-md-9 px-3 px-md-0">
              <div class="form-group mb-4">
                <label for="tipo_persona" class="text-lg">Tipo persona:</label>
                <select
                  name="tipo_persona"
                  id="tipo_persona"
                  class="form-control"
                  required
                  @change="togglePersonaMoral($event.target.value)"
                >
                  <option value="FISICA">FISICA</option>
                  <option value="MORAL">MORAL</option>
                </select>
              </div>
            </div>
          </div>
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-12 col-md-9 px-3 px-md-0">
              <div class="form-group mb-4">
                <label for="rfc" class="text-lg">RFC:</label>
                <input
                  type="text"
                  class="form-control"
                  id="rfc"
                  name="rfc"
                  autocomplete="off"
                  placeholder="Ingresa tu RFC aquí"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bg-light pb-5" v-if="showMoral">
          <div class="d-flex col-md-8 mx-auto">
            <div class="col-md-1 d-flex justify-content-center">
              <span>4</span>
            </div>
            <div class="col-md-11">
              <p class="pb-3">
                <b class="text-dark">Nombre de la empresa y RFC</b><br />
                <span class="text-dark">
                  Si estás solicitando una cotización en nombre de una empresa,
                  ingresa el nombre de la empresa y su RFC. Esto nos permite
                  comprender mejor tus necesidades comerciales y ofrecerte las
                  mejores opciones de arrendamiento.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 pb-5" v-if="showMoral">
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-md-9">
              <div class="form-group mb-4" v-if="showMoral">
                <label for="empresa" class="text-lg">Empresa:</label>
                <input
                  type="text"
                  placeholder="Escribe aquí"
                  id="empresa"
                  name="empresa"
                  class="form-control"
                  autocomplete="off"
                  required
                />
              </div>
              <div class="form-group mb-4" v-if="showMoral">
                <label for="representante_legal" class="text-lg"
                  >Representante legal:</label
                >
                <input
                  type="text"
                  id="representante_legal"
                  name="representante_legal"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Escribe aquí"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bg-light"></div>
        <div class="col-md-6 pb-4">
          <div class="text-center col-md-9">
            <button
              type="submit"
              class="btn btn-lg rounded-pill bg-dark text-white"
            >
              Siguiente paso
            </button>
          </div>
        </div>
      </div>
    </form>
    <div>
      <CTAContactoAsesor />
    </div>
  </section>
</template>
